import React from 'react';
import { IAddress } from '../../types/location/address';
import { ILocation } from '../../types/location/location';

interface IAddressProps {
  minimal?: boolean;
  location?: ILocation;
  address?: IAddress;
  className?: string;
  showFull?: boolean;
  unit?: string;
  locationPriorityOrder?: string[];
  skip?: string[];
}

const Address: React.FC<React.PropsWithChildren<React.PropsWithChildren<IAddressProps>>> = ({
  location,
  className,
  unit,
  showFull,
  address,
  skip = [],
  locationPriorityOrder = [
    'unit',
    'locality',
    'neighborhood',
    'place',
    'region',
    'country',
  ],
  minimal,
}) => {
  const result = React.useMemo(() => {
    if (!location && !address) {
      return '';
    }
    address = address || location?.address;
    if (showFull) {
      return `${(unit && `Unit ${unit}, `) || ''}${address?.placeName}`;
    }

    const fields = locationPriorityOrder.filter(
      (field) => !skip.includes(field)
    );

    const locationArray = fields
      .map(
        (field) =>
          (field === 'unit' && unit && `unit ${unit}`) || address?.[field] || ''
      )
      .filter((item) => item);

    if (minimal) {
      return locationArray[0];
    }
    return locationArray.join(', ');
  }, [location, address, minimal, unit, showFull]);

  return <span className={className}>{result}</span>;
};
export default React.memo(Address);
